import React from 'react'
import { AiFeaturePreset } from '../../../../../models/AiFeaturePreset'
import { PresetInputParametersHierarchyConfigModal } from '../PresetInputParametersHierarchyConfigModal'
import { GlobalPresetConfigForm } from './Hierarchy/GlobalPresetConfigForm'
import { MeetingTemplateCurrentUserInputParameterConfigForm } from '../../../../../components/InputParameterHierarchy/Form/MeetingTemplateCurrentUserInputParameterConfigForm'
import { MeetingTemplateTeamMemberInputParameterConfigForm } from '../../../../../components/InputParameterHierarchy/Form/MeetingTemplateTeamMemberInputParameterConfigForm'

export interface PresetConfigModalProps {
  show: boolean
  onHide: () => void
  preset: AiFeaturePreset
}

export const PresetFormConfigModal: React.FC<PresetConfigModalProps> = ({ show, onHide, preset }) => {
  return (
    <PresetInputParametersHierarchyConfigModal
      show={show}
      onHide={onHide}
      preset={preset}
      GlobalConfig={GlobalPresetConfigForm}
      CurrentUserConfig={MeetingTemplateCurrentUserInputParameterConfigForm}
      TeamMembersConfig={MeetingTemplateTeamMemberInputParameterConfigForm}
    />
  )
}
